import axios from 'axios';
import { FunctionCallCache } from './functionCallCache';
export class HttpClient {
    static axiosClient = null;
    static setAxiosClient(client) {
        this.axiosClient = client;
    }
    static axios() {
        if (!this.axiosClient) {
            throw new Error('AlphaScriptHttpClient is not initialized');
        }
        return this.axiosClient;
    }
    static isRenderPluginMode() {
        return !!FunctionCallCache.RENDER_PLUGIN_MODE;
    }
    static getRenderPluginToken() {
        const token = FunctionCallCache.USER_TOKEN;
        if (!token) {
            throw new Error('Render plugin mode is enabled but USER_TOKEN is missing');
        }
        return token;
    }
    static buildAbsoluteUrl(url) {
        const baseUrl = process.env.API_URL;
        if (!baseUrl) {
            throw new Error('API_URL is not configured');
        }
        if (url.startsWith('http://') || url.startsWith('https://')) {
            return url;
        }
        return `${baseUrl}${url}`;
    }
    static async post(url, data, config) {
        if (this.isRenderPluginMode()) {
            const token = this.getRenderPluginToken();
            return axios.post(this.buildAbsoluteUrl(url), data, {
                ...config,
                headers: {
                    ...(config?.headers || {}),
                    Authorization: `Bearer ${token}`,
                },
            });
        }
        return this.axios().post(url, data, config);
    }
}
//# sourceMappingURL=httpClient.js.map